"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

var _Box = _interopRequireDefault(require("../Box"));

var __jsx = _react["default"].createElement;

/**
 * Helper component placing components next to each other with gutter.
 *
 * Gutter can be responsive but items layout can not. So it's usable ONLY if on all resolutions items will be next to each other and won't wrap.
 */
function HorizontalStack(_ref) {
  var sx = _ref.sx,
      gap = _ref.gap,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["sx", "gap"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  var gutter = gap || customSx.$gutter || 0;
  return (0, _.jsx)(_Box["default"], (0, _extends2["default"])({
    sx: [{
      display: "flex",
      flexWrap: "nowrap",
      alignItems: "center",
      " > *": {
        marginRight: gutter,
        ":last-child": {
          marginRight: 0
        }
      }
    }, css]
  }, restProps));
}

var _default = HorizontalStack;
exports["default"] = _default;